import { Component, Inject, Input, OnInit } from '@angular/core';
import { AppSettingService } from "@/angular-blocworx/components/admin/app-setting/app-setting.service";

@Component({
  selector: 'other-settings-app-setting',
  templateUrl: 'angular-blocworx/components/admin/app-setting/other-settings/other-settings-app-setting.html',
})
export class OtherSettingsAppSetting implements OnInit {
  // Suggest passing in a settings object so you can add lots of settings later
  @Input() silencePromptSound: any;
  @Input() main: any;


  constructor(@Inject(AppSettingService) private appSettingService: AppSettingService) {}

	ngOnInit(): void {
   if (this.silencePromptSound === '') {
            this.silencePromptSound = "0";
        }
  }

  async setAppSetting(settingKey: string, settingValue: string) {
    const cartolyticsCustomerId = localStorage.getItem('cartolyticsCustomerID');
    await this.appSettingService.setAppSetting(cartolyticsCustomerId, settingKey, settingValue);
  }
}
